export default __webpack_public_path__ + "static/completePayment-51ed159684913f0383736de1d29a83bc.svg";